var map = {
	"./icons/original/hint-adjacent.png": "Qj03",
	"./icons/original/hint-between.png": "IJZH",
	"./icons/original/hint-direction.png": "Op0r",
	"./icons/original/hint-tile.png": "qwlA",
	"./icons/original/large/large-a1.png": "QP0S",
	"./icons/original/large/large-a2.png": "NhLW",
	"./icons/original/large/large-a3.png": "4I4A",
	"./icons/original/large/large-a4.png": "ytF8",
	"./icons/original/large/large-a5.png": "TeOI",
	"./icons/original/large/large-a6.png": "N7YA",
	"./icons/original/large/large-b1.png": "UBU4",
	"./icons/original/large/large-b2.png": "w35o",
	"./icons/original/large/large-b3.png": "/BPU",
	"./icons/original/large/large-b4.png": "BRDO",
	"./icons/original/large/large-b5.png": "YKaq",
	"./icons/original/large/large-b6.png": "mPGt",
	"./icons/original/large/large-c1.png": "+bsQ",
	"./icons/original/large/large-c2.png": "oXIE",
	"./icons/original/large/large-c3.png": "XjqR",
	"./icons/original/large/large-c4.png": "mGEC",
	"./icons/original/large/large-c5.png": "rxGk",
	"./icons/original/large/large-c6.png": "oJmq",
	"./icons/original/large/large-d1.png": "cgSM",
	"./icons/original/large/large-d2.png": "oD70",
	"./icons/original/large/large-d3.png": "PWPq",
	"./icons/original/large/large-d4.png": "D3DT",
	"./icons/original/large/large-d5.png": "1Tjk",
	"./icons/original/large/large-d6.png": "q9gS",
	"./icons/original/large/large-e1.png": "ZvN9",
	"./icons/original/large/large-e2.png": "dcOB",
	"./icons/original/large/large-e3.png": "91Mv",
	"./icons/original/large/large-e4.png": "SAo3",
	"./icons/original/large/large-e5.png": "hli+",
	"./icons/original/large/large-e6.png": "YFuY",
	"./icons/original/large/large-f1.png": "ZNit",
	"./icons/original/large/large-f2.png": "zU+P",
	"./icons/original/large/large-f3.png": "gVWB",
	"./icons/original/large/large-f4.png": "yFfv",
	"./icons/original/large/large-f5.png": "t+UZ",
	"./icons/original/large/large-f6.png": "dSmd",
	"./icons/original/small/small-a1.png": "qpPT",
	"./icons/original/small/small-a2.png": "nVYH",
	"./icons/original/small/small-a3.png": "x5BK",
	"./icons/original/small/small-a4.png": "Htyr",
	"./icons/original/small/small-a5.png": "uVvn",
	"./icons/original/small/small-a6.png": "pqg3",
	"./icons/original/small/small-b1.png": "27d+",
	"./icons/original/small/small-b2.png": "6b+j",
	"./icons/original/small/small-b3.png": "RUP8",
	"./icons/original/small/small-b4.png": "romA",
	"./icons/original/small/small-b5.png": "fZOX",
	"./icons/original/small/small-b6.png": "Z31m",
	"./icons/original/small/small-c1.png": "kbZK",
	"./icons/original/small/small-c2.png": "gBE2",
	"./icons/original/small/small-c3.png": "mcFw",
	"./icons/original/small/small-c4.png": "90E6",
	"./icons/original/small/small-c5.png": "AQov",
	"./icons/original/small/small-c6.png": "20Ho",
	"./icons/original/small/small-d1.png": "C7Cf",
	"./icons/original/small/small-d2.png": "xDob",
	"./icons/original/small/small-d3.png": "Dvz/",
	"./icons/original/small/small-d4.png": "iXl1",
	"./icons/original/small/small-d5.png": "d6hy",
	"./icons/original/small/small-d6.png": "hFVX",
	"./icons/original/small/small-e1.png": "SCQN",
	"./icons/original/small/small-e2.png": "uLm8",
	"./icons/original/small/small-e3.png": "E9CV",
	"./icons/original/small/small-e4.png": "XnXw",
	"./icons/original/small/small-e5.png": "P2+R",
	"./icons/original/small/small-e6.png": "lgdU",
	"./icons/original/small/small-f1.png": "voAe",
	"./icons/original/small/small-f2.png": "xFS2",
	"./icons/original/small/small-f3.png": "Hoba",
	"./icons/original/small/small-f4.png": "yNUn",
	"./icons/original/small/small-f5.png": "MjYr",
	"./icons/original/small/small-f6.png": "QfaF",
	"./icons/original/tile.png": "FslU",
	"./rain-light.png": "8OvN",
	"./rain.png": "kCQN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7PiI";


//////////////////
// WEBPACK FOOTER
// ./src/web \.png$
// module id = 7PiI
// module chunks = app